@let currentLanguage = this.currentLanguage();
@let isEnglish = currentLanguage === 'en-CA';
@let isFrench = currentLanguage === 'fr-CA';

<div class="label">EN</div>
<div
  class="switcher"
  [class.selected-en]="isEnglish"
  [class.selected-fr]="isFrench"
  coreActivitySection="LanguageSwitcher"
  [coreUserActivityClickTracking]="isEnglish ? 'SwitchLanguageToFrench' : 'SwitchLanguageToEnglish'"
>
  <div class="slider"></div>
  <button
    (click)="changeLanguage(isEnglish ? 'fr-CA' : 'en-CA')"
  ></button>
  <button
    (click)="changeLanguage(isFrench ? 'en-CA' : 'fr-CA')"
  ></button>
</div>
<div class="label">FR</div>
